import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  BenefitDetailsCardContentStyled,
  BenefitDetailsCardDesignIconStyled,
  BenefitDetailsCardDesignStyled,
  BenefitDetailsCardGridStyled,
  BenefitDetailsCardRequiredTextStyled,
  BenefitDetailsPaperLabelStyled,
  BenefitDetailsPaperProgressReqStatusStyled,
  BenefitDetailsPaperProgressStatusStyled,
  BenefitDetailsPaperStyled,
} from './BenefitDetailsStyled';
import { BenefitDetailsCardListDto } from './types';
import { CheckCircleStyled } from 'enrollment/components/Header/components/CartDrawer/CartDrawerStyled';

interface BenefitDetailsCardProps {
  handleBenefitDetailsCard: (details: BenefitDetailsCardListDto) => void | null;
  benefitDetailsCardList: BenefitDetailsCardListDto[];
}

export const BenefitDetailsCard = ({
  handleBenefitDetailsCard,
  benefitDetailsCardList,
}: BenefitDetailsCardProps) => {
  const { t } = useTranslation('pages.enrollmentBeneficiaries');

  if (benefitDetailsCardList.length < 1) {
    return null;
  }

  const isComplete = (status: string) => {
    const statusSplit = status.split('/');
    return statusSplit[0] === statusSplit[1];
  };

  return (
    <Grid container>
      {benefitDetailsCardList.map((item) => {
        return (
          <BenefitDetailsCardGridStyled
            item
            sm={12}
            md={6}
            lg={6}
            key={item.id}
            onClick={() => handleBenefitDetailsCard(item)}
          >
            <BenefitDetailsPaperStyled>
              <BenefitDetailsCardDesignStyled>
                <svg
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 0H60V10C60 37.6142 37.6142 60 10 60H0V0Z"
                    fill="#DEE7FF"
                  />
                </svg>
                <BenefitDetailsCardDesignIconStyled>
                  {item.icon}
                </BenefitDetailsCardDesignIconStyled>
              </BenefitDetailsCardDesignStyled>
              <BenefitDetailsCardContentStyled>
                <BenefitDetailsPaperLabelStyled
                  direction="row"
                  alignItems="center"
                >
                  <h3 className="my-0">{item.title}</h3>
                </BenefitDetailsPaperLabelStyled>
                <Typography variant="body2">{item.description}</Typography>
                {item.status && (
                  <Grid>
                    <BenefitDetailsPaperProgressStatusStyled
                      spacing={1}
                      direction="row"
                      $isComplete={isComplete(item.status)}
                    >
                      {isComplete(item.status) && (
                        <CheckCircleStyled size={32} />
                      )}
                      <Typography variant="subtitle2">{item.status}</Typography>
                      <Typography variant="subtitle2">
                        {t('benefitDetailsPaperProgressLabelName')}
                      </Typography>
                    </BenefitDetailsPaperProgressStatusStyled>
                    <BenefitDetailsPaperProgressReqStatusStyled>
                      <BenefitDetailsCardRequiredTextStyled variant="subtitle2">
                        {item.required}
                      </BenefitDetailsCardRequiredTextStyled>
                    </BenefitDetailsPaperProgressReqStatusStyled>
                  </Grid>
                )}
              </BenefitDetailsCardContentStyled>
            </BenefitDetailsPaperStyled>
          </BenefitDetailsCardGridStyled>
        );
      })}
    </Grid>
  );
};
